import React from 'react';
import { Sparkles, ShieldCheck, Zap } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const GroomingPage = () => {
  const config = {
    badge: "Pet Grooming",
    headline: "Professional",
    headlineItalic: "Grooming.",
    subtext: "Expert, gentle grooming services using veterinary-grade products that keep your pet's coat, skin, and hygiene in pristine condition.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Professional Pet Grooming at Dr. Suresh Pet Care — Expert Grooming Services",
    stats: [
      { value: 5000, suffix: '+', label: 'Grooms Completed' },
      { value: 100, suffix: '%', label: 'Vet-Safe Products' },
      { value: 10, suffix: '+', label: 'Breed Specialists' },
      { value: 5, suffix: '★', label: 'Client Rating' },
    ],
    services: [
      {
        title: "Full Grooming Package",
        icon: <Sparkles size={28} />,
        desc: "Bath, blow-dry, breed-specific styling, nail clipping, ear cleaning, and hygienic trimming.",
        specs: ["Medicated Shampoo", "Blow Dry & Style", "Nail Trimming", "Ear Cleaning"],
        color: "from-violet-500/10 to-primary/10"
      },
      {
        title: "Medicated Grooming",
        icon: <ShieldCheck size={28} />,
        desc: "Therapeutic baths with veterinary-grade anti-fungal, anti-bacterial, and anti-parasitic products.",
        specs: ["Anti-fungal Bath", "De-shedding", "Anti-parasite Dip", "Skin Conditioning"],
        color: "from-primary/10 to-pink-500/10"
      },
      {
        title: "Breed Styling",
        icon: <Zap size={28} />,
        desc: "Precision breed-standard styling for Poodles, Shih Tzus, and other long-coat breeds by expert groomers.",
        specs: ["Breed-Standard Cut", "Show Preparation", "Top-knot Styling", "Scissor Finish"],
        color: "from-rose-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Grooming",
    sectionItalic: "Services.",
    warningTitle: "Grooming",
    warningItalic: "Health Benefits.",
    warningText: "Regular grooming is not just aesthetic — it directly contributes to your pet's skin health, coat condition, and early disease detection.",
    warnings: [
      { name: "Coat Matting", desc: "Severe matting causes skin irritation, infections, and restricts blood flow.", icon: "🐕" },
      { name: "Nail Overgrowth", desc: "Long nails cause joint pain, posture issues, and risk of painful splitting.", icon: "🦴" },
      { name: "Ear Hygiene", desc: "Regular ear cleaning prevents chronic infections and hearing problems.", icon: "👂" },
      { name: "Parasite Detection", desc: "Grooming sessions allow early detection of fleas, ticks, and skin lesions.", icon: "🔍" },
    ],
    ctaBadge: "Expert Grooming",
    ctaTitle: "The Grooming",
    ctaItalic: "Experience.",
    ctaText: "Our expert grooming team combines aesthetic skill with veterinary knowledge to ensure every session is a safe, stress-free, and beautiful experience.",
    ctaBtn: "Book a Grooming Session",
    seoText: "Professional pet grooming in Hyderabad. Dog and cat grooming services at Dr. Suresh Pet Care. Medicated baths, breed styling, and nail trimming.",
    glowColor: "violet-500"
  };

  return (
    <>
      <SEO 
        title="Pet Grooming Services in Vanasthalipuram"
        description="Keep your pets clean, healthy, and comfortable with our professional grooming services including bathing, nail trimming, and ear cleaning in Hyderabad."
        canonical="/grooming"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default GroomingPage;
